const hasSignedForm = (filer, formName) => {
    if (!filer || !formName) {
        return false;
    }

    if (filer[formName]) {
        return true;
    }

    const normalizedFormName = formName.toLowerCase();
    return Object.keys(filer).some((key) => key && key.toLowerCase() === normalizedFormName && filer[key]);
}

export const isT183 = (filer) => {
    return hasSignedForm(filer, 'T183');
}

export const hasPrimarySignedT183 = (signedDocuments) => {
    return signedDocuments && (isT183(signedDocuments.primary) || isT183(signedDocuments.self));
}

export const hasSpouseSignedT183 = (signedDocuments) => {
    return signedDocuments && isT183(signedDocuments.spouse);
}

